import React, {Component} from 'react';
import {connect} from "react-redux";
import MaterialIcon from '../../MaterialIcon';
import {clickedNodeAction} from "../../../actions/clickedNodeActions";
import axios from "axios";
import {showToastForBackend} from "../../../actions/toastActions";
import PanelLayout from "../components/PanelLayout";
import axiosConfig from "../../../utils/axiosConfig";
import messageCodes from "../../../utils/messageCodes";
import logicGraphDataActions from "../../../actions/logicGraphDataActions";
import {removePort, addPort} from '../components/InputPortListUtils/InputPortUtils';

import uniqueId from 'lodash/uniqueId';

class ComponentPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            logics: [],
            chosenLogic: "",
            portList: []
        };
        this.getLogicList = this.getLogicList.bind(this);
        this.updatePortOption = this.updatePortOption.bind(this);
        this.removePort = this.removePort.bind(this);
        this.addPort = this.addPort.bind(this);
    }

    componentDidMount() {
        if (this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.chosenLogic) {
            this.setState({chosenLogic: this.props.clickedNodeInfo.extras.options.chosenLogic})
        }
        
        this.setState({portList: this.createPortList(this.props.clickedNodeInfo.ports)})
        this.getLogicList();
    }

    createPortList(ports) {
        const portList = [];
        const clickedNodeInfo = Object.assign({}, this.props.clickedNodeInfo);
        Object.values(ports).forEach((v,i) => {
            const createData = {
                parentID: clickedNodeInfo.options.id,
                id: v.options.id,
                nodeName: 'Empty Input',
                branchName: '',
                groupID: uniqueId(),
                index: i,
                roundRobin: false,
                edit: false,
                sectionType: 'empty',
                groupData: {
                    groupID: uniqueId(),
                    rounds: 1,
                    randomizeAllRounds: false,
                    randomizeInsideRound: false
                },
                exclude: false,
                itemCount: null,
                logDecisionValue: '',
                randomize: false,
                useUnder: null,
                in: v.options.in
            }
            portList.push(createData);
        });
        return portList;
    }

    getLogicList() {
        axios.get(this.props.properties.logicUrl, axiosConfig())
            .then((response) => {
                this.setState({
                    logics: response.data
                        .filter(logic => logic.id !== +window.location.href.split("/").slice(-3)[0])
                        .sort(
                            (a, b) => a.name > b.name ? 1 : -1
                        )
                });
            })
            .catch((err) => {
                if (err.response) {
                    this.props.showToastForBackend(err.response.data);
                } else {
                    this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                }
            });
    }

    updateChosenLogicOption() {
        let id = +this.state.chosenLogic;
        let type = this.state.logics.find(logic => logic.id === id).type
        this.setInput(type === "COMPONENT")

        let clickedNodeInfo = Object.assign({}, this.props.clickedNodeInfo);
        clickedNodeInfo.extras.options.chosenLogic = id;
        this.props.clickedNodeAction(clickedNodeInfo);
    }

    setInput(isRequired) {
        const portList = this.state.portList
        const inPort = Object.values(portList).find(port => port.in)
        if (!isRequired && inPort) this.removePort(inPort);
        if (isRequired && !inPort) this.addPort();
    }

    updatePortOption() {
        const inputPortData = [];
        const portList = Object.values(Object.assign({}, this.state.portList));

        const inputPortList = portList.filter(port => port.in);
        inputPortList.forEach(v => {
            inputPortData.push({
                logDecisionValue: v.logDecisionValue,
                predicate: v.predicate
            });
        });

        const options = Object.assign({}, this.state.options);
        options.chosenLogic = this.state.chosenLogic
        options.inputPortData = inputPortData;
        options.logDecisionName = this.props.clickedNodeInfo.extras.options.logDecisionName;

        const logicGraphData = {
            options: options,
            portList: portList,
            id: this.props.clickedNodeInfo.options.id
        }
        this.props.logicGraphDataActions(logicGraphData);
    }

    removePort(item) {
        const portList = removePort(this.state.portList, item);
        this.setState({
            portList: portList
        }, () => this.updatePortOption());

    }

    addPort() {
        const portList = addPort(this.state, this.props.clickedNodeInfo.options.id, 'component');
        this.setState({
            portList: portList
        }, () => this.updatePortOption());
    }

    onLogicSelectedChange(event) {
        this.setState({chosenLogic: event.target.value},
            () => {
                this.updateChosenLogicOption()
            })
    }

    openLogicInNewTab(event) {
        event.preventDefault();
        const url = "/logics/" + this.state.chosenLogic;
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    render() {
        return (
            <PanelLayout className="editorial-panel">
                <div className="filter-group">
                    <div className="filter-group-content">
                        <div className="filter-rule">
                            <form className="input-container" onSubmit={() => console.log("submitted")}>
                                <div className="form-select">
                                    {!this.props.hideArrow &&
                                        <span className="arrow"><MaterialIcon icon="keyboard_arrow_down"
                                                                            size={24}/></span>
                                    }
                                    <select onChange={(event) => this.onLogicSelectedChange(event)}
                                            value={this.state.chosenLogic}>
                                        {this.state.chosenLogic === "" ? <option value="" disabled>Choose logic...</option> : null}
                                        {this.state.logics.length > 0 ?
                                            this.state.logics.map((x, y) =>
                                                <option key={y} value={x.id}>{x.name}</option>) :
                                            <option value="" disabled>There is no logics</option>
                                        }
                                    </select>
                                </div>
                                <div className="request-button">
                                    <button className="action-button save-button" 
                                            onClick={(e) => this.openLogicInNewTab(e)}>
                                        <span className="button-label">Open&nbsp;Logic</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </PanelLayout>
        )
    }


}

function mapStateToProps(state) {
    return {
        node: state.modalInfo.node,
        clickedNodeInfo: state.clickedNodeInfo,
        properties: state.properties,
        logicDataInfo: state.logicDataInfo,
        logicGraphData: state.logicGraphData
    }
}

export default connect(mapStateToProps, {
    clickedNodeAction,
    showToastForBackend,
    logicGraphDataActions
})(ComponentPanel);